/* Klara Clone — header tweaks
   Splits the desktop nav into two halves around the centered logo
   (Impulse-style), so the result matches the reference storefront. */
(function () {
  function splitHeaderNav() {
    var header = document.querySelector('.header--middle-center');
    if (!header) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var nav = header.querySelector('.header__inline-menu');
    if (!nav || nav.getAttribute('data-mb-split')) return;

    var ul = nav.querySelector('ul.list-menu--inline');
    if (!ul) return;

    var items = Array.prototype.slice.call(ul.children).filter(function (n) {
      return n.nodeType === 1;
    });
    if (items.length < 2) return;

    var mid = Math.ceil(items.length / 2);

    var rightNav = document.createElement('nav');
    rightNav.className = 'header__inline-menu header__inline-menu--right';
    var rightUl = ul.cloneNode(false);
    rightNav.appendChild(rightUl);

    // appendChild MOVES the node out of the left list into the right list
    for (var i = mid; i < items.length; i++) {
      rightUl.appendChild(items[i]);
    }

    var heading = header.querySelector('.header__heading');
    if (heading && heading.parentNode === header) {
      header.insertBefore(rightNav, heading.nextSibling);
    } else {
      header.appendChild(rightNav);
    }

    nav.setAttribute('data-mb-split', '1');
  }

  /* Reference puts the search icon FAR-LEFT and the cart FAR-RIGHT.
     Move the whole <details-modal class="header__search"> node (modal content
     travels with it, so it keeps working) to be a direct child of the header;
     CSS then pins it to the left. Desktop only. */
  function moveSearchLeft() {
    var header = document.querySelector('.header--middle-center');
    if (!header) return;
    if (window.matchMedia('(max-width: 989px)').matches) return;

    var search = header.querySelector('.header__search');
    if (!search || search.getAttribute('data-mb-moved')) return;
    if (search.parentNode === header) { search.setAttribute('data-mb-moved', '1'); return; }

    header.insertBefore(search, header.firstChild);
    search.setAttribute('data-mb-moved', '1');
  }

  function applyHeaderTweaks() {
    splitHeaderNav();
    moveSearchLeft();
  }

  if (document.readyState !== 'loading') {
    applyHeaderTweaks();
  } else {
    document.addEventListener('DOMContentLoaded', applyHeaderTweaks);
  }
  // Re-apply after Dawn rebuilds the sticky header / on editor section reload
  document.addEventListener('shopify:section:load', applyHeaderTweaks);
})();

/* Klara Clone — variant thumbs on product cards (Dulvera-style):
   hovering a thumb (or scrubbing across the photo) swaps the card image;
   clicking a thumb navigates to that variant. Delegated, so it works for
   every card on every page including AJAX-loaded recommendations. */
(function () {
  if (window.__mbCardThumbsInit) return;
  window.__mbCardThumbsInit = true;

  function mbSelectThumb(thumb) {
    var wrapper = thumb.closest('.card-wrapper') || thumb.closest('.card');
    if (!wrapper) return;
    var media = wrapper.querySelector('.card__media');
    if (!media) return;
    var newSrc = thumb.getAttribute('data-mb-thumb');
    if (newSrc) {
      /* Dawn cards stack TWO images (primary + secondary hover layer).
         Swap the src on EVERY image so whichever layer is visible
         reflects the selected variant. */
      var imgs = media.querySelectorAll('img');
      for (var k = 0; k < imgs.length; k++) {
        if (imgs[k].src !== newSrc) {
          imgs[k].setAttribute('srcset', '');
          imgs[k].src = newSrc;
        }
      }
    }
    var sibs = wrapper.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
    thumb.classList.add('is-active');
  }

  /* Preload a card's variant photos on first hover so swaps are instant. */
  function mbPreload(wrap) {
    if (!wrap || wrap.__mbPreloaded) return;
    wrap.__mbPreloaded = true;
    var ts = wrap.querySelectorAll('.mb-card__thumb');
    for (var i = 0; i < ts.length; i++) {
      var s = ts[i].getAttribute('data-mb-thumb');
      if (s) { var im = new Image(); im.src = s; }
    }
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    mbPreload(e.target.closest('.card-wrapper') || e.target.closest('.card'));
    var thumb = e.target.closest('.mb-card__thumb');
    if (thumb) mbSelectThumb(thumb);
  }, { passive: true });

  /* Thumbs are real <a href> links to their variant — only stop the click
     bubbling to the card-wide product link. */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest && e.target.closest('.mb-card__thumb');
    if (!thumb) return;
    e.stopPropagation();
  });

  /* Scrub: moving the cursor across the photo cycles through the variants
     (photo split into N zones, one per thumb). */
  document.addEventListener('mousemove', function (e) {
    var media = e.target.closest && e.target.closest('.card__media');
    if (!media) return;
    var wrapper = media.closest('.card-wrapper') || media.closest('.card');
    if (!wrapper) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs.length < 2) return;
    var rect = media.getBoundingClientRect();
    var frac = (e.clientX - rect.left) / rect.width;
    if (frac < 0) frac = 0;
    if (frac > 0.999) frac = 0.999;
    var idx = Math.floor(frac * thumbs.length);
    var target = thumbs[idx];
    if (target && !target.classList.contains('is-active')) mbSelectThumb(target);
  }, { passive: true });

  /* Revert to the first variant photo when the cursor leaves the card. */
  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest && e.target.closest('.card-wrapper');
    if (!wrapper) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    var thumbs = wrapper.querySelectorAll('.mb-card__thumb');
    if (thumbs[0]) mbSelectThumb(thumbs[0]);
  }, { passive: true });
})();

/* Klara Clone — PDP hover previews:
   1) hovering a colour photo-swatch shows that variant's photo in the gallery;
   2) hovering a sidebar gallery thumbnail switches the main photo (no click needed).
   Both reuse Dawn's own thumbnail click handler / media-gallery API. */
(function () {
  if (window.__mbPdpHoverInit) return;
  window.__mbPdpHoverInit = true;

  function mbShowMedia(target) {
    if (!target) return;
    /* Dawn puts data-target on the thumbnail LI; the clickable button is inside it */
    var li = document.querySelector('.thumbnail-list__item[data-target="' + target + '"]');
    var btn = li && li.querySelector('.thumbnail');
    if (btn) {
      if (btn.getAttribute('aria-current') !== 'true') btn.click();
      return;
    }
    var gal = document.querySelector('media-gallery');
    if (gal && typeof gal.setActiveMedia === 'function') gal.setActiveMedia(target, true);
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    var sw = e.target.closest('label.mb-photo-swatch[data-mb-target]');
    if (sw) {
      mbShowMedia(sw.getAttribute('data-mb-target'));
      return;
    }
    var li = e.target.closest('.thumbnail-list__item[data-target]');
    if (li) {
      var btn = li.querySelector('.thumbnail');
      if (btn && btn.getAttribute('aria-current') !== 'true') btn.click();
    }
  }, { passive: true });
})();
